import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (trackingId) => {
  ReactGA.initialize(trackingId);
};

// Track page views
export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

// Track events
export const logEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

// Track events - GA4 სტილით (ახალი)
export const logEventGA4 = (eventName, eventParams = {}) => {
  ReactGA.event(eventName, eventParams);
};
